module.exports = __webpack_public_path__ + "sf-pro-text-regular.svg?1b73d682d10c0aea7a321b4b6af23cc8";